import _ from 'lodash';
import actionTypes from '../actions/action_types';

const initialState = {
  pages: {},
};

export default function reducer(state = initialState, action) {
  let result;

  switch (action.type) {
    case actionTypes.FACEBOOK_PAGES_LOADED: {
      result = _.assign({}, state, {
        pages: _.keyBy(action.payload.pages, 'pageId'),
      });
      break;
    }

    case actionTypes.FACEBOOK_PAGE_ADDED: {
      const page = action.payload.page;
      result = _.assign({}, state);
      result.pages[page.pageId] = page;
      result.error = null;
      break;
    }

    case actionTypes.FACEBOOK_INVALID_ID_ADDED: {
      const error = action.payload;
      result = _.assign({}, state);
      result.error = error;
      break;
    }

    case actionTypes.FACEBOOK_PAGE_REMOVED: {
      result = _.assign({}, state);
      delete result.pages[action.payload.pageId];
      break;
    }

    case actionTypes.FACEBOOK_PAGE_UPDATED: {
      const page = action.payload.page;
      result = _.assign({}, state);
      result.pages[page.pageId] = page;
      break;
    }

    case actionTypes.FACEBOOK_ADD_DIALOG_OPENED: {
      result = _.assign({}, state);
      result.error = null;
      break;
    }

    default: {
      result = _.assign({}, state);
    }

  }

  return result;
}



// WEBPACK FOOTER //
// ./src/reducers/facebook.js